type Service = {
  title: string;
  body: string;
  bullets: string[];
  accent: string;
  icon: React.ReactNode;
};

const services: Service[] = [
  {
    title: "Win the job before they hang up",
    body: "Stop losing leads to whoever picks up first. We wire up automatic quote drafts, instant lead follow-up, and reminders that don't forget — so the customer hears back from you before your competitor even calls back.",
    bullets: [
      "Instant lead response, day or night",
      "Quotes drafted in minutes, not days",
      "Follow-ups that never get forgotten",
    ],
    accent: "var(--yellow)",
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
        <path d="M12 3v2M12 19v2M5 12H3M21 12h-2M5.6 5.6l1.4 1.4M17 17l1.4 1.4M5.6 18.4 7 17M17 7l1.4-1.4" />
        <circle cx="12" cy="12" r="4" />
      </svg>
    ),
  },
  {
    title: "Your back office, on autopilot",
    body: "Invoices, scheduling, dispatch, paperwork, AR — the stuff that keeps your office staff working late and your cash sitting on the table. We automate it so the boring work happens by itself and your team gets their evenings back.",
    bullets: [
      "Invoices, COIs, and paperwork that fill themselves",
      "Dispatch and scheduling that don't drop the ball",
      "Cash hits the bank faster — fewer 'where's my invoice?' calls",
    ],
    accent: "var(--orange)",
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
        <rect x="3" y="4" width="18" height="14" rx="2" />
        <path d="M7 9h2M11 9h6M7 13h4M15 13h2" />
        <path d="M8 22h8M12 18v4" />
      </svg>
    ),
  },
  {
    title: "One team. One number to call.",
    body: "No revolving door of freelancers. No 'we'll get back to you' from some agency. Fixed-scope build or month-to-month retainer — we learn your business, ship the system, and stick around when something needs to change.",
    bullets: [
      "Fixed-scope builds with a fixed price",
      "Month-to-month retainer, cancel anytime",
      "Same team that built it answers when you call",
    ],
    accent: "var(--sky)",
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
        <path d="M3 12h4l3-8 4 16 3-8h4" />
      </svg>
    ),
  },
];

export function Services() {
  return (
    <section className="section services" id="services">
      <div className="container">
        <div className="services-head">
          <span className="eyebrow">What we do</span>
          <h2 className="section-title">Run the business. Stop running yourself into the ground.</h2>
          <p className="section-sub">
            We build custom software for the businesses that build everything else
            &mdash; contractors, trades, manufacturers, shops. The boring parts
            (quoting, scheduling, paperwork, follow-ups) get automated. You stop
            answering emails at 9pm.
          </p>
        </div>

        <div className="services-grid">
          {services.map((s) => (
            <article
              key={s.title}
              className="service-card"
              style={{ ["--accent" as never]: s.accent }}
            >
              <div className="service-icon">{s.icon}</div>
              <h3 className="service-title">{s.title}</h3>
              <p className="service-body">{s.body}</p>
              <ul className="service-list">
                {s.bullets.map((b) => (
                  <li key={b}>{b}</li>
                ))}
              </ul>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
